// CUSTOM TEMPLATES
export const GET_CUSTOM_TEMPLATES_KEY = 'useGetCustomTemplates';
export const GET_CUSTOM_TEMPLATE_KEY = 'useGetCustomTemplate';
export const GET_CUSTOM_TOPICS_TEMPLATE_KEY = 'useGetCustomTopicsTemplate';
export const GET_SELECTED_TOPICS_KEY = 'useSelectedTopics';

// DYNAMIC CATEGORIES
export const DISCUSSIONS_CATEGORIES_QUERY_KEY =
  'dynamic_search_discussions_categories';
export const EVENTS_CATEGORIES_QUERY_KEY = 'dynamic_search_events_categories';
export const TOPICS_CATEGORIES_QUERY_KEY = 'dynamic_search_topics_categories';
export const NEWS_CATEGORIES_QUERY_KEY = 'dynamic_search_news_categories';
export const POSTS_CATEGORIES_QUERY_KEY = 'dynamic_search_posts_categories';

// DYNAMIC SEARCH
export const DISCUSSIONS_QUERY_KEY = 'dynamic_search_discussions';
export const EVENTS_QUERY_KEY = 'dynamic_search_events';
export const TOPICS_QUERY_KEY = 'dynamic_search_topics';
export const NEWS_QUERY_KEY = 'dynamic_search_news';
export const POSTS_QUERY_KEY = 'dynamic_search_posts';
export const USERS_QUERY_KEY = 'dynamic_search_users';
